import React, { Fragment } from 'react'
import "./Reports.css";
import { getSuperheadeingColor, getSubeingColor, getSupersubeingColor } from './Reports.js';
function DQI_Config({ dqi_params, isclicked, thresholdColorsDqi }) {

  const reporttype = "config2";
  const getDQIColor = (value) => {
    const matchingColor = thresholdColorsDqi?.find(colors => value <= parseInt(colors.maxThresholdValue));

    if (matchingColor) {
      return { backgroundColor: matchingColor.backgroundColor, color: matchingColor.color };
    }
  };

  if (dqi_params?.data?.businessUnit) {

    let totalLogs = 0;

    // Calculate the total number of logs
    dqi_params?.data?.businessUnit.forEach(provider => {
      provider?.rigs.forEach(rig => {
        rig?.wells.forEach(well => {
          totalLogs += well?.logs?.length;
        });
      });
    });

    //   const truncateText = (text) => {
    //     if (text && text.length > 5) {
    //         return text.substring(0, 5) + '...';
    //     }
    //     return text;
    // };

    //   const truncateText = (text) => {
    //     if (text && text.length > 5) {
    //         let truncatedText = '';
    //         for (let i = 0; i < text.length; i += 5) {
    //             truncatedText += text.substring(i, i + 5) + '\n';
    //         }
    //         return truncatedText.trim(); // Remove extra newline at the end and return
    //     }
    //     return text;
    // };

    const truncateText = (text) => {
      if (text && text.includes('(')) {
        const openingBracketIndex = text.indexOf('(');
        const truncatedText = text.substring(0, openingBracketIndex) + '\n' + text.substring(openingBracketIndex);
        return truncatedText;
      }
      return text;
    };

    const filteredBusinessUnit = dqi_params.data.businessUnit
    .map(unit => ({
        ...unit,
        rigs: unit.rigs
            .map(rig => ({
                ...rig,
                wells: rig.wells.filter(well => well.logs.length > 0)
            }))
            .filter(rig => rig.wells.length > 0)
    }))
    .filter(unit => unit.rigs.length > 0);

    return (
      <Fragment>{
        (filteredBusinessUnit.length > 0) ?
          <>
            <table className="tree-view">
              <thead>
                <tr style={getSuperheadeingColor()}><th colSpan={5}><b>Config Report</b></th></tr>
                <tr style={getSubeingColor()}>
                  <th className='forCenter'><b>Buisness Unit</b></th>
                  <th className='forCenter'><b>Rig</b></th>
                  <th className='forCenter'><b>Well</b></th>
                  <th className='forCenter'><b>Log</b></th>
                  <th className='forCenter'><b>Index Type</b></th>
                </tr>
              </thead>
              <tbody>
                {


                  filteredBusinessUnit.map(provider => {
                    let totalProviderLogs = provider.rigs.reduce((acc, rig) => {
                      return acc + rig.wells.reduce((accWell, well) => {
                        return accWell + well.logs.length;
                      }, 0);
                    }, 0);

                    return provider.rigs.map((rig, rigIndex) => {
                      let totalRigLogs = rig.wells.reduce((acc, well) => acc + well.logs.length, 0);
                      return rig.wells.map((well, wellIndex) => (
                        well.logs.map((log, logIndex) => (
                          <tr key={`${provider.name}-${rig.name}-${well.name}-${log.name}`}>
                            {(rigIndex === 0 && wellIndex === 0 && logIndex === 0) && (
                              <td className='forCenter' rowSpan={totalProviderLogs} >{provider.name}</td>
                            )}
                            {(wellIndex === 0 && logIndex === 0) && (
                              <td className='forCenter' rowSpan={totalRigLogs} >{rig.name}</td>
                            )}
                            {(logIndex === 0) && <td className='forCenter' rowSpan={well.logs.length}>{well.name}</td>}
                            <td className='forCenter'>{log.name || "-"}</td>
                            <td className='forCenter'>{log.indexType || "-"}</td>

                          </tr>
                        ))
                      ))
                    })
                  })
                }
              </tbody>
            </table>
            <div>
              {
                filteredBusinessUnit.map(provider => (
                  provider?.rigs.map(rig => (
                    rig?.wells.map(well => (
                      <div key={`${provider?.name}-${rig?.name}-${well?.name}`} style={{ width: "100%", paddingRight: "15px" }}>
                        {/* Section for Rig, Well, and Log names */}
                        <div style={{ marginTop: "35px" }}>
                          <table className="tree-view">
                            <tr style={getSupersubeingColor()}>
                              <td className='forCenter'><b> Business Unit: {provider.name}</b></td>
                              <td className='forCenter'><b> Rig: {rig.name}</b></td>
                              <td className='forCenter'><b> Well: {well.name}</b></td>
                            </tr>
                          </table>
                        </div>
                        {well?.logs?.map(log => (
                          <div key={`${provider?.name}-${rig?.name}-${well?.name}-${log?.name}`}>
                            {/* Section for Log */}
                            {log?.mnemonics[0]?.name && (
                              <table className="tree-view">
                                <tr>
                                  <td>
                                    <b>Log: {log.name}</b>
                                  </td>
                                </tr>
                              </table>
                            )}
                            {log?.mnemonics[0]?.name && (
                              <table className="mnemonics-view">
                                <thead>
                                  <tr style={getSubeingColor()}>
                                    {/* <th className='forCenter' ><b>Mnemonic</b></th>
                                <th className='forCenter' ><b>UoM</b></th>
                                <th className='forCenter' ><b>Permissible Trouble Occurrences</b></th>
                                <th className='forCenter' ><b>Trouble Time Threshold</b></th>
                                <th className='forCenter' ><b>Max Value Weightage</b></th>
                                <th className='forCenter' ><b>Min Value Weightage</b></th>
                                <th className='forCenter' ><b>Frequency Weightage</b></th>
                                <th className='forCenter' ><b>Precision Weightage</b></th>
                                <th className='forCenter' ><b>Data Gap Weightage</b></th>
                                <th className='forCenter' ><b>Stale Value Weightage</b></th>
                                <th className='forCenter' ><b>Expected Max Value</b></th>
                                <th className='forCenter' ><b>Expected Min Value</b></th>
                                <th className='forCenter' ><b>Expected Interval</b></th>
                                <th className='forCenter' ><b>Required Precision</b></th>
                                <th className='forCenter' ><b>Allowed Data Gap</b></th>
                                <th className='forCenter' ><b>Allowed Staleness</b></th> */}

                                    <th className='forCenter'><b>Channel</b></th>
                                    <th className='forCenter'><b>DQI</b></th>
                                    <th className='forCenter'><b>UoM</b></th>
                                    {/* <th className='forCenter'><b>Permissible Trouble Occurrences</b></th>
                                    <th className='forCenter'><b>Trouble Threshold</b></th> */}
                                    <th className='forCenter'><b>Expected Max Value</b></th>
                                    <th className='forCenter'><b>Expected Min Value</b></th>
                                    <th className='forCenter'><b>Frequency Interval</b></th>
                                    <th className='forCenter'><b>Required Precision</b></th>
                                    <th className='forCenter'><b>Allowed Data Gap</b></th>
                                    <th className='forCenter'><b>Allowed Staleness</b></th>
                                    <th className='forCenter'><b>Max Value DQI</b></th>
                                    <th className='forCenter'><b>Min Value DQI</b></th>
                                    <th className='forCenter'><b>Frequency DQI</b></th>
                                    <th className='forCenter'><b>Precision DQI</b></th>
                                    <th className='forCenter'><b>Data Gap DQI</b></th>
                                    <th className='forCenter'><b>Staleness DQI</b></th>
                                    <th className='forCenter'><b>DataCount DQI</b></th>
                                    <th className='forCenter'><b>Latency DQI</b></th>

                                  </tr>
                                </thead>
                                <tbody>
                                  {log.mnemonics.map(mnemonic => (
                                    <tr key={`${provider?.name}-${rig?.name}-${well?.name}-${log?.name}-${mnemonic?.name}`}>
                                      {/* <td className='forCenter' ><b>{truncateText(mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name)}</b></td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].UoM === "" ? "-" : mnemonic?.aspects?.[0].UoM === 0 ? 0 : mnemonic?.aspects?.[0].UoM)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === "" ? "-" : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === 0 ? 0 : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Trouble_Time_Threshold === "" ? "-" : mnemonic?.aspects?.[0].Trouble_Time_Threshold === 0 ? 0 : mnemonic?.aspects?.[0].Trouble_Time_Threshold)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Max_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Max_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Max_value_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Min_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Min_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Min_value_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Frequency_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Frequency_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Frequency_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Precision_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Precision_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Precision_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Data_gap_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Data_gap_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Data_gap_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Stale_value_Weightage === "" ? "-" : mnemonic?.aspects?.[0].Stale_value_Weightage === 0 ? 0 : mnemonic?.aspects?.[0].Stale_value_Weightage)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Expected_Max_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Max_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Max_Value)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Expected_Min_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Min_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Min_Value)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Expected_Interval === "" ? "-" : mnemonic?.aspects?.[0].Expected_Interval === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Interval)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Required_Precision === "" ? "-" : mnemonic?.aspects?.[0].Required_Precision === 0 ? 0 : mnemonic?.aspects?.[0].Required_Precision)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Allowed_Data_Gap === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Data_Gap === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Data_Gap)}</td>
                                  <td className='forCenter' >{truncateText(mnemonic?.aspects?.[0].Allowed_Staleness === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Staleness === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Staleness)}</td> */}

                                      <td className='forRight'><b>{truncateText(mnemonic.name === "" ? "-" : mnemonic.name === 0 ? 0 : mnemonic.name)}</b></td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Channel_DQI)}>{truncateText(mnemonic?.aspects?.[0].Channel_DQI === "" ? "-" : mnemonic?.aspects?.[0].Channel_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Channel_DQI)}</td>
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].UoM === "" ? "-" : mnemonic?.aspects?.[0].UoM === 0 ? 0 : mnemonic?.aspects?.[0].UoM)}</td>
                                      {/* <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === "" ? "-" : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences === 0 ? 0 : mnemonic?.aspects?.[0].Permissible_Trouble_Occurrences)}</td>
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Trouble_Time_Threshold === "" ? "-" : mnemonic?.aspects?.[0].Trouble_Time_Threshold === 0 ? 0 : mnemonic?.aspects?.[0].Trouble_Time_Threshold)}</td> */}
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Max_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Max_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Max_Value)}</td>
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Min_Value === "" ? "-" : mnemonic?.aspects?.[0].Expected_Min_Value === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Min_Value)}</td>
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Expected_Interval === "" ? "-" : mnemonic?.aspects?.[0].Expected_Interval === 0 ? 0 : mnemonic?.aspects?.[0].Expected_Interval)}</td>
                                      <td className='forCenter'>{truncateText(mnemonic?.aspects?.[0].Required_Precision === "" ? "-" : mnemonic?.aspects?.[0].Required_Precision === 0 ? 0 : mnemonic?.aspects?.[0].Required_Precision)}</td>
                                      <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Data_Gap === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Data_Gap === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Data_Gap)}</td>
                                      <td className='forRight'>{truncateText(mnemonic?.aspects?.[0].Allowed_Staleness === "" ? "-" : mnemonic?.aspects?.[0].Allowed_Staleness === 0 ? 0 : mnemonic?.aspects?.[0].Allowed_Staleness)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Max_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Max_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Max_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Max_value_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Min_value_DQI)}>{truncateText(mnemonic?.aspects?.[0].Min_value_DQI === "" ? "-" : mnemonic?.aspects?.[0].Min_value_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Min_value_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Frequency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Frequency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Frequency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Frequency_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Precision_DQI)}>{truncateText(mnemonic?.aspects?.[0].Precision_DQI === "" ? "-" : mnemonic?.aspects?.[0].Precision_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Precision_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Data_gap_DQI)}>{truncateText(mnemonic?.aspects?.[0].Data_gap_DQI === "" ? "-" : mnemonic?.aspects?.[0].Data_gap_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Data_gap_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Staleness_DQI)}>{truncateText(mnemonic?.aspects?.[0].Staleness_DQI === "" ? "-" : mnemonic?.aspects?.[0].Staleness_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Staleness_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].DataCount_DQI)}>{truncateText(mnemonic?.aspects?.[0].DataCount_DQI === "" ? "-" : mnemonic?.aspects?.[0].DataCount_DQI === 0 ? 0 : mnemonic?.aspects?.[0].DataCount_DQI)}</td>
                                      <td className='forCenter' style={getDQIColor(mnemonic?.aspects?.[0].Latency_DQI)}>{truncateText(mnemonic?.aspects?.[0].Latency_DQI === "" ? "-" : mnemonic?.aspects?.[0].Latency_DQI === 0 ? 0 : mnemonic?.aspects?.[0].Latency_DQI)}</td>

                                    </tr>
                                  ))}
                                </tbody>
                              </table>


                            )}
                          </div>
                        ))}
                      </div>
                    ))
                  ))
                ))}
            </div></>
          : <p style={{ textAlign: "center", fontWeight: "700" }}>Config Data not Found</p>}
      </Fragment>
    );
  }
  else {
    return "No Config Data Found"
  }
}
export default DQI_Config;